
import isTouchDevice from 'is-touch-device'

import 'flatpickr/dist/l10n/de'
if (isTouchDevice()) {
  document.body.classList.add('touch')
} else {
  document.body.classList.add('not-touch')
}


import initMenuMobile from './components/Menu/MenuMobile'
import initMenuDesktop from './components/Menu/Menu'
initMenuMobile()
initMenuDesktop()

import '../scss/style.scss'
